/**
 * The ONE client-side definition of a disputed finding (DC-1799 → DC-1806),
 * mirroring `server/banking/assessment/runReadModel.isDisputedFinding`
 * verbatim. Results flags disputed rows, the Decision tab surfaces them at
 * the point of judgement — both through this module, so the two surfaces can
 * never disagree about what a dispute is.
 *
 * The rule: a finding is disputed when a measurement or manual entry decided
 * its outcome AND a confirmed contradicting attestation was retained on it.
 * An `attested_contradiction` finding is NOT disputed — there the
 * contradiction IS the ruling, and flagging it twice would say the same
 * thing louder.
 *
 * The authoritative COUNT comes from the server (`disputedCount` on results
 * and history payloads); this module identifies WHICH findings those are,
 * for drill-downs.
 */

import type { RunFinding } from './assessmentTypes';

export interface EvidenceRef {
  itemId: string;
  linkId: string;
  kind: string;
}

export function contradictedByOf(finding: RunFinding): EvidenceRef[] {
  const raw = finding.detail?.contradictedBy;
  return Array.isArray(raw) ? (raw as EvidenceRef[]) : [];
}

export function isDisputed(finding: RunFinding): boolean {
  const basis = finding.detail?.basis;
  return (
    (basis === 'data_collector' || basis === 'manual_metric_entry') &&
    contradictedByOf(finding).length > 0
  );
}
